module.exports = __webpack_public_path__ + "img/missao.b06c8346.svg";